export interface StaffMemberRole {
  roleId: string
  roleName?: string
  hourlyRate: number
  role?: StaffMemberPosRole
  payClassificationId?: string | null
  payClassificationName?: string
  payClassificationVariationId?: string | null
}

interface StaffMemberPosRole {
  posIdentifier: string
  name: string
}

// Function to apply transformations to RemunerationSnapshot object on get
export const transformMemberRolesOnSave = (
  memberRoles: StaffMemberRole
): StaffMemberRole => {
  return {
    ...memberRoles,
    payClassificationId:
      memberRoles.payClassificationId == ''
        ? null
        : memberRoles.payClassificationId,
  }
}
